import React from "react";
import {
    Box,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormHelperText,
    MenuItem,
    Radio,
    Select,
    Typography
} from "@material-ui/core";
import { BasicInput, BasicInputSelect } from "../RightSideStyle";

const DynamicInputField = (props) => {
    const handleCommonField = (e) => {
        let value = e.target.value;
        const normalizeDate = (dateStr) => {
           if (!dateStr || typeof dateStr !== "string") return "";
           dateStr = dateStr.trim();

           // Format: YYYY-MM-DD
           if (dateStr.includes("-")) {
             let [year, month, day] = dateStr.split("-");

             year = year.slice(-4); // ✅ last 4 digits
             month = month.padStart(2, "0");
             day = day.padStart(2, "0");

             return `${month}/${day}/${year}`;
           }

           // Format: MM/DD/YYYY (or longer year)
           if (dateStr.includes("/")) {
             let [month, day, year] = dateStr.split("/");

             if (!year || !month || !day) return "";

             year = year.slice(-4); // ✅ last 4 digits
             month = month.padStart(2, "0");
             day = day.padStart(2, "0");

             return `${month}/${day}/${year}`;
           }
           return "";
        };

        const normalizeDateTime = (dateTimeStr) => {
           if (!dateTimeStr || typeof dateTimeStr !== "string") return "";
           dateTimeStr = dateTimeStr.trim();

           const [datePart, timePartRaw] = dateTimeStr.split("T");
           if (!datePart || !timePartRaw) return "";

           const formattedDate = normalizeDate(datePart);
           if (!formattedDate) return "";

           const timePart = timePartRaw.split(".")[0]; // remove milliseconds if presen

           return `${formattedDate} ${timePart}`;
        };
    
        if (props.fieldType === 'date') {
            value = normalizeDate(value);
        } else if (props.fieldType === 'datetime') {
            value = normalizeDateTime(value);
        }
    
        props.callback({
            [`${props.title}-${props.data.id}`]: {
                id: props.data.id,
                value: value
            }
        });
    };


    const handleCheckBox = (event, defaultValue) => {
        let check = event.target.checked;
        let data = '';
        let newValue = event.target.value;

        if (check) {
            if (defaultValue === '')
                data = newValue;
            else
                data = defaultValue + "," + newValue;
        } else {
            if (defaultValue.indexOf(newValue) === 0) {
                if (defaultValue.indexOf(newValue + ',') === 0)
                    data = defaultValue.replace(newValue + ',', "");
                else
                    data = defaultValue.replace(newValue, "");
            } else {
                data = defaultValue.replace(',' + newValue, "");
            }
        }

        props.callback({
            [`${props.title}-${props.data.id}`]: {
                id: props.data.id,
                value: data
            }
        });
    }

    const SelectBox = ({ value, onChange }) => {

        return (
            <FormControl fullWidth>
                <Select
                    labelId='dropdown-label'
                    id='dropdown'
                    value={value}
                    displayEmpty
                    onChange={onChange}
                    input={<BasicInputSelect />}
                    inputProps={{ "aria-label": "Without label" }}
                    MenuProps={{
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                        },
                        transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                        },
                        getContentAnchorEl: null,
                    }}
                >
                    <MenuItem className='dropdownhelper-menuitem-class' value={''}>
                        {`Select ${props.title}`}
                    </MenuItem>
                    {
                        props.data &&
                        props.data.default_values &&
                        props.data.default_values.map((item, index) => (
                            <MenuItem key={index} className='dropdownhelper-menuitem-class' value={item}>
                                {item}
                            </MenuItem>
                        ))
                    }
                </Select>
            </FormControl>
        );
    };

    const RadioBox = ({ value, onChange }) => {
        let content = null;

        if (props.data && props.data.default_values) {
            content = props.data.default_values.map((data, index) => {
                let checked = (data === value) ? "checked" : null;
                return (
                    <FormControlLabel
                        key={index}
                        control={<Radio checked={Boolean(checked)} onChange={onChange} name="radio-move" value={data} />}
                        label={data}
                    />
                );
            });
        }

        return (
            <Box sx={{ display: "flex", flexDirection: "row", gap: "6px", flexWrap: "wrap" }}>
                {content}
            </Box>
        );
    };

    const CheckBox = ({ onChange, value }) => {
        let content = null;
        let userValues = [];
        if (value) {
            userValues = value.split(',');
        }
        if (props.data && props.data.default_values) {
            content = props.data.default_values.map((data, index) => {
                let checked = (userValues.indexOf(data) > -1) ? 'checked' : null;

                return (
                    <FormControlLabel
                        key={index}
                        control={<Checkbox checked={Boolean(checked)} onChange={onChange} name="radio-move" value={data} />}
                        label={data}
                    />
                );
            });
        }
        return (
            <Box sx={{ display: "flex", flexDirection: "row", gap: "6px", flexWrap: "wrap" }}>
                {content}
            </Box>
        );
    };


        function convertToISODate(input) {
          if (!input || typeof input !== "string") {
            // console.warn("Invalid input: Not a string or is empty.");
            return "";
          }

          // Check if already in ISO format
          const isoRegex = /^\d{4}-\d{2}-\d{2}$/;
          if (isoRegex.test(input)) {
            // console.log("Input is already in ISO format.");
            return input;
          }

          // Match MM/DD/YYYY or M/D/YYYY
          const regex = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
          const match = input.match(regex);

          if (!match) {
            // console.warn("Input does not match MM/DD/YYYY format.");
            return "";
          }

          let [_, mm, dd, yyyy] = match;

          // Pad month and day with leading zeros
          const paddedMM = mm.padStart(2, "0");
          const paddedDD = dd.padStart(2, "0");

          const isoFormatted = `${yyyy}-${paddedMM}-${paddedDD}`;
          console.log("Converted to ISO format:", isoFormatted);
          return isoFormatted;
        }

        function convertToISODatetime(input) {
          if (!input || typeof input !== "string") return "";

          input = input.trim();
          console.log("Converted to ISO format:", input);

          // Case 1: Already ISO-like with time (YYYY-MM-DDTHH:mm or YYYY-MM-DD HH:mm)
          const isoRegex = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2})?$/;
          if (isoRegex.test(input)) {
            const [datePart, timePart] = input.split(/[ T]/);
            const [year, month, day] = datePart.split("-");
            const [hh, min] = timePart.split(":");
            return `${year}-${month}-${day}T${hh.padStart(
              2,
              "0"
            )}:${min.padStart(2, "0")}`;
          }

          // Case 2: MM/DD/YYYY HH:mm (or with seconds)
          const fullDateTimeRegex =
            /^(\d{1,2})\/(\d{1,2})\/(\d{4})[ T](\d{1,2}):(\d{2})(?::(\d{2}))?$/;
          const fullMatch = input.match(fullDateTimeRegex);
          if (fullMatch) {
            const [_, mm, dd, yyyy, hh, min] = fullMatch;
            return `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(
              2,
              "0"
            )}T${hh.padStart(2, "0")}:${min.padStart(2, "0")}`;
          }

          // Case 3: MM/DD/YYYY → default time to 00:00
          const usDateOnlyRegex = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
          const usDateMatch = input.match(usDateOnlyRegex);
          if (usDateMatch) {
            const [_, mm, dd, yyyy] = usDateMatch;
            return `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(
              2,
              "0"
            )}T00:00`;
          }

          // ✅ Case 4: YYYY-MM-DD (ISO date only) → default time to 00:00
          const isoDateOnlyRegex = /^(\d{4})-(\d{1,2})-(\d{1,2})$/;
          const isoDateMatch = input.match(isoDateOnlyRegex);
          if (isoDateMatch) {
            const [_, yyyy, mm, dd] = isoDateMatch;
            return `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(
              2,
              "0"
            )}T00:00`;
          }

          return ""; // Fallback if nothing matches
        }



    const renderField = () => {
        let field = null;
        let defaultValue = props.values[`${props.title}-${props.data.id}`] ? props.values[`${props.title}-${props.data.id}`].value : '';

        if (props.fieldType === "text") {
            field = <BasicInput fullWidth type="text" onChange={handleCommonField} value={defaultValue} placeholder={`Enter ${props.title}`} />;
        } else if (props.fieldType === "date") {

            const isoDate = convertToISODate(defaultValue); // MM/DD/YYYY -> YYYY-MM-DD

            field = <BasicInput fullWidth type="date" onChange={handleCommonField} value={isoDate} placeholder={`Enter ${props.title}`} />;
        } else if (props.fieldType === "datetime") {
            // const formatInitialDate = (dateString) => {
            //     if (dateString) {
            //         const dateObject = new Date(dateString);
            //         const offset = dateObject.getTimezoneOffset();
            //         dateObject.setMinutes(dateObject.getMinutes() - offset);
            //         return dateObject.toISOString().slice(0, 16);
            //     }
            // };
            const isoDate = convertToISODatetime(defaultValue); // MM/DD/YYYY -> YYYY-MM-DD

            field = <BasicInput fullWidth type="datetime-local" onChange={handleCommonField} value={isoDate} placeholder={`Enter ${props.title}`} />;
        } else if (props.fieldType === "number") {
            field = <BasicInput fullWidth type="number" onChange={handleCommonField} value={defaultValue} placeholder={`Enter ${props.title}`} maxLength={props.maxLength} />;
        } else if (props.fieldType === "select") {
            field = <SelectBox onChange={handleCommonField} value={defaultValue} />;
        } else if (props.fieldType === "radio") {
            field = <RadioBox onChange={handleCommonField} value={defaultValue} />;
        } else if (props.fieldType === "checkbox") {
            field = <CheckBox onChange={(event) => { handleCheckBox(event, defaultValue) }} value={defaultValue} />;
        } else {
            field = <BasicInput fullWidth type="text" multiline onChange={handleCommonField} value={defaultValue} placeholder={`Enter ${props.title}`} />;
        }

        return field;
    };

    return (
        <Box>
            <Typography variant='body1' color='textPrimary'>{props.data.title}</Typography>
            {renderField()}
            {
                props.error &&
                <FormHelperText>
                    {props.error}
                </FormHelperText>
            }
        </Box>
    );
}

export default DynamicInputField;
